import {
    server
} from "@/api";

const prefix = 'api/sessions'

const adminPrefix = 'api/admin/sessions'

export const admin = {
    create: async (session) => {
        return await server().post(adminPrefix, session, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    get: async (id, params = {}) => {
        return await server().get(`${adminPrefix}/${id}`, { params });
    },
    paginate: async (params) => {
        return await server().get(adminPrefix, { params });
    },
    update: async (id, session) => {
        return await server().post(`${adminPrefix}/${id}`, session, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    destroy: async (id) => {
        return await server().delete(`${adminPrefix}/${id}`);
    },
    edit: async (id) => {
        return await server().get(`${adminPrefix}/${id}/edit`);
    }
}

export const paginate = async (params) => {
    return await server().get(prefix, { params });
}

export const get = async (id, params = {}) => {
    return await server().get(`${prefix}/${id}`, { params });
}

export const join = async (sessionId) => {
    return await server().post(`${prefix}/${sessionId}/join`);
}

export const leave = async (sessionId) => {
    return await server().post(`${prefix}/${sessionId}/leave`);
}

const sessionApi = {
    get,
    paginate,
    join,
    leave,
    admin
};

export default sessionApi;